export const TYPES = ['fatal', 'error', 'warning', 'info', 'success', 'debug', 'trace'];

export const MODULES = ['Application', 'Auth', 'Cache', 'Database', 'Sync', 'UI'];